module.exports = __webpack_public_path__ + "static/media/deaf.a8791a54.svg";